import React from 'react'
import {useHistory} from 'react-router-dom'

import {Box, Theme, Typography} from '@mui/material'
import {makeStyles} from 'tss-react/mui'

import {RouteEnum, useRoutes} from '@progyny/routes'

type ArticleCategory = {
  imageUrl: string
  slug: string
  name: string
}
interface RelatedCategoriesProps {
  segments: ArticleCategory[]
  title: string
}

const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    position: 'relative',
    minWidth: 150,
    cursor: 'pointer',
    alignItems: 'center',
    display: 'flex',
    backgroundColor: theme.palette.other.brandColors.disabledGray,
    marginBottom: theme.spacing(2),
    borderRadius: 8,
  },
  title: {
    padding: '12px 16px',
    alignSelf: 'center',
  },
}))

const RelatedCategories: React.ComponentType<RelatedCategoriesProps> = ({
  segments,
  title,
}: RelatedCategoriesProps) => {
  const {classes} = useStyles()
  const history = useHistory()
  const {getPath} = useRoutes()

  return (
    <>
      <Typography variant={'body1'} fontWeight={600} mb={3}>
        {title}
      </Typography>
      <Box mt={1}>
        {segments?.map((topic) => {
          return (
            <Box
              key={topic.slug}
              role={'link'}
              onClick={() =>
                history.push(
                  `${getPath(RouteEnum.KNOWLEDGE_CENTER)}/${topic.slug}`
                )
              }
              className={classes.container}
            >
              <Box className={classes.title}>
                <Typography variant={'subtitle1'}>{topic.name}</Typography>
              </Box>
            </Box>
          )
        })}
      </Box>
    </>
  )
}

export default RelatedCategories
